import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import CompanySubNav from '../../components/CompanySubNav';
import SEO from '../../components/SEO';
import '../../styles/company-about.css';

export default function CompanyAbout() {
  const [company, setCompany] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    let mounted = true;
    async function fetchCompany() {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL || ''}/companies/${id}`);
        if (mounted) setCompany(res.data);
      } catch (err) {
        console.error(err);
      }
    }
    fetchCompany();
    return () => { mounted = false; };
  }, [id]);

  return (
    <div>
      <SEO
        title={company ? `About ${company.name}` : 'Company Profile'}
        description={company?.description || 'View this company profile on Dofcan Oilserve.'}
        path={`/company/${id}/about`}
      />

      <CompanySubNav companyId={id} active="about" />

      {!company ? (
        <div className="company-loading">Loading...</div>
      ) : (
        <div className="company-about">
          <h1>{company.name}</h1>
          <p>{company.description}</p>
        </div>
      )}
    </div>
  );
}
